import { useFormik } from "formik"
import * as Yup from "yup"
import { editByIdFamilias } from "../../../Services/familiaService"
import { useEffect, useState } from "react"
import { getAllDepartamentosV2 } from "../../../Services/departamentoService"

const useEdit = (history, location) => {
  const familia = location?.state?.familia
  const [departamentos, setDepartamentos] = useState([])

  // validacion del formulario
  const formikEdit = useFormik({
    initialValues: {
      nombre: familia?.nombre,
      ganancia: familia?.ganancia,
      departamento: familia?.departamento,
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required('Obligatorio.'),
      ganancia: Yup.number()
        .required('Obligatorio.')
        .min(0, 'El numero debe ser positivo.'),
      departamento: Yup.object().required('Obligatorio.'),
    }),
    onSubmit: (values) => editFamilia(values),
  })

  const editFamilia = (values) => {
    let familiaUpdated = {
      nombre: values.nombre,
      ganancia: values.ganancia,
      departamentoId: values.departamento.id,
      id: familia?.id,
    }

    editByIdFamilias(familiaUpdated)
      .then((res) => {
        history.goBack()
      })
      .catch((error) => {
        console.log(error.response.data)
        this.setState({ error: true })
      })
  }

  useEffect(() => {
    getAllDepartamentosV2(true, 0, '', 100)
      .then((res) => setDepartamentos(res.data.content))
      .catch((err) => console.error(err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      setDepartamentos(null)
    }
  }, [])



  return { formikEdit, departamentos }
}

export default useEdit